/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's the difference between a percent and a percentage point?`)
};

const es_pct_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la diferencia entre un porcentaje y un punto porcentual?`)
};

const de_pct_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der Unterschied zwischen einem Prozent und einem Prozentpunkt?`)
};

const nl_pct_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het verschil tussen een percentage en een procentpunt?`)
};

const fr_pct_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la différence entre un pourcentage et un point de pourcentage ?`)
};

const it_pct_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la differenza tra una percentuale e un punto percentuale?`)
};

const pt_br2_pct_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre um por cento e um ponto percentual?`)
};

const pt_pct_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre uma percentagem e um ponto percentual?`)
};

const ja_pct_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセントとパーセンテージポイントの違いは？`)
};

const zh_pct_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比和百分点有什么区别？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_hub_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_hub_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_hub_faq4_q", locale)
	if (locale === "en") return en_pct_hub_faq4_q(inputs)
	if (locale === "es") return es_pct_hub_faq4_q(inputs)
	if (locale === "de") return de_pct_hub_faq4_q(inputs)
	if (locale === "nl") return nl_pct_hub_faq4_q(inputs)
	if (locale === "fr") return fr_pct_hub_faq4_q(inputs)
	if (locale === "it") return it_pct_hub_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_hub_faq4_q(inputs)
	if (locale === "pt") return pt_pct_hub_faq4_q(inputs)
	if (locale === "ja") return ja_pct_hub_faq4_q(inputs)
	return zh_pct_hub_faq4_q(inputs)
};